import * as React from "react";
import { RadioGroupProps } from "./RadioGroup";
import "./RadioGroup.scss";

const RadioGroup: React.FunctionComponent<RadioGroupProps> = ({
    name,
    className,
    children = [],
    onChange,
}: RadioGroupProps) => {
    const reportUp = (id: string, value: "yes" | "no") => {
        if (onChange && onChange instanceof Function) {
            onChange(name, value);
        }
    };
    return (
        <ul className={`OSRadioGroup ${className}`}>
            {React.Children.map(children, (child: any) => {
                if (!child) {
                    return null;
                }
                return React.cloneElement(child, {
                    key: `radio${name}_${child.props ? child.props.id : ""}`,
                    name,
                    reportUp,
                });
            })}
        </ul>
    );
};

RadioGroup.defaultProps = {
    className: "",
};

export default RadioGroup;
